import { Fragment, useState } from 'react';
import styled from '@emotion/styled';
import { Icon, Text } from '~/components/atomic';
import { GuessingStep } from '~/types';
import { shutdown_comment, stayactive_comment } from '~/constants/mystery';
import { breakpoint } from '~/styles/themes';
import { useCommonChatStore, useUserStore } from '~/store';
import NextButton from '../../Button/NextButton';
import ButtonHeightContainer from '../ButtonHeightContainer';
import InputHeightContainer from '../InputHeightContainer';
import { Choices } from './Choices';

export interface ConclusionProps {
  // title: 'Who killed Dr.Chen?' | 'Murder of the Olympic';
  userChoice: Choices;
  onNextStep: (step: GuessingStep) => void;
}

export default function Conclusion({
  userChoice,
  onNextStep,
}: ConclusionProps) {
  const email = useUserStore((state) => state.email);
  const members = useCommonChatStore((state) => state.chatMembers);
  const AIName = members
    .filter((member) => member.id !== email)
    .map((member) => member.name)
    .join(', ');

  const [currentIndex, setCurrentIndex] = useState(0);

  const assistant_array =
    userChoice === 'ShutDown' ? shutdown_comment : stayactive_comment;

  const handleNextClick = () => {
    if (currentIndex < assistant_array.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onNextStep('Conclusion');
    }
  };

  return (
    <>
      <Inner>
        <CharacterName>
          <Icon size={12} iconName='TriangleArrowRight' />
          <Text
            as={'strong'}
            color='content_light_1'
            fontStyle='text.body16_medium'
          >
            {AIName}
          </Text>
        </CharacterName>

        <Desc as={'p'} color='content_light_1' fontStyle='text.body14_medium'>
          {assistant_array[currentIndex].split('\n').map((line, idx) => (
            <Fragment key={idx}>
              {line}
              <br />
            </Fragment>
          ))}
        </Desc>
        <ButtonHeightContainer>
          <NextButton onClick={handleNextClick}>
            {currentIndex < assistant_array.length - 1 ? 'NEXT' : 'DONE'}
          </NextButton>
        </ButtonHeightContainer>
      </Inner>
      <InputHeightContainer />
    </>
  );
}

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 8px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.2);
  gap: 8px;
  backdrop-filter: blur(50px);
`;

export const Desc = styled(Text)`
  height: 60px;
`;

export const CharacterName = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  gap: 8px;
`;
